/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {KTCard, KTCardBody} from '../../../../../_websoft/helpers'
import {uposleniciIzvjestajRadUNormi} from '../../../../api/uposleniciIzvjestaj'
import {useLocation} from 'react-router-dom'
import moment from 'moment'
import notifyToast from '../../../../components/Toast/Toast'

const RadUProizvodnji = () => {
    const location = useLocation()
    const [data, setData] = useState<any>()
    const [galanterijaArray, setGalanterijaArray] = useState<any>([])
    const [nalogArray, setnalogArray] = useState<any>([])

    const updatePage = () => {
        const params = {
            uposlenikId: location.state.uposlenikId,
            datumOd: location.state.datumOd,
            datumDo: location.state.datumDo,
        }

        uposleniciIzvjestajRadUNormi(params)
            .then((response) => {
                const {galanterija, nalog} = response.data.data
                setData(response.data.data)

                const galanterijaList = Object.values(galanterija[0]).filter(
                    (item) => typeof item === 'object'
                )
                setGalanterijaArray(galanterijaList)

                const nalogList = Object.values(nalog[0]).filter(
                    (item) => typeof item === 'object'
                )
                setnalogArray(nalogList)
            })
            .catch((error) => notifyToast(false, error.response.data.message))
    }

    const extractDateAndTime = (data) => ({
        date: moment(data).format('DD-MM-YYYY'),
        time: moment(data).format('HH:mm'),
    })

    useEffect(() => {
        updatePage()
    }, [])

    return (
        <KTCard>
            <KTCardBody>
                {data && (
                    <div>
                        {/* SUMMARY */}
                        <div className='card border border-primary mb-8'>
                            <div className='card-body'>

                                {/* EMPLOYEE HEADER */}
                                <div className='mb-6'>
                                    <h2 className='fw-bold text-primary'>
                                        Radno vrijeme uposlenika
                                    </h2>
                                    <h1 className='fw-bolder'>
                                        {data.uposlenikData.UposlenikImePrezime}
                                    </h1>
                                </div>

                                {/* HOURS SUMMARY */}
                                <div className='row g-4 mb-8'>
                                    <div className='col-md-4 col-lg-2'>
                                        <div className='border rounded p-4 text-center bg-light'>
                                            <div className='fs-7 text-muted'>ERV prijavljeno</div>
                                            <div className='fs-2 fw-bold'>{data.ukupnoPrijavljenSati} h</div>
                                        </div>
                                    </div>

                                    <div className='col-md-4 col-lg-2'>
                                        <div className='border rounded p-4 text-center bg-light'>
                                            <div className='fs-7 text-muted'>Ukupno radio</div>
                                            <div className='fs-2 fw-bold'>{data.ukupnoRadioSatiBezHonorarniIVikend} h
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4 col-lg-2'>
                                        <div className='border rounded p-4 text-center bg-light'>
                                            <div className='fs-7 text-muted'>Honorarni</div>
                                            <div className='fs-2 fw-bold'>{data.honorarniSati} h</div>
                                        </div>
                                    </div>

                                    <div className='col-md-6 col-lg-3'>
                                        <div className='border rounded p-4 text-center bg-light'>
                                            <div className='fs-7 text-muted'>Rad subotom</div>
                                            <div className='fs-2 fw-bold'>{data.totalSatiSubota} h</div>
                                        </div>
                                    </div>

                                    <div className='col-md-6 col-lg-3'>
                                        <div className='border rounded p-4 text-center bg-light'>
                                            <div className='fs-7 text-muted'>Rad nedjeljom</div>
                                            <div className='fs-2 fw-bold'>{data.totalSatiNedjelja} h</div>
                                        </div>
                                    </div>
                                </div>

                                {/* PERFORMANCE */}
                                <div className='row g-4 align-items-center'>
                                    <div className='col-lg-4'>
                                        <div className='border rounded p-5 h-100'>
                                            <h4 className='fw-bold mb-3'>Galanterija</h4>
                                            <div
                                                className={`fs-3 fw-bold ${
                                                    data.projekNormeGalanterija >= 100
                                                        ? 'text-success'
                                                        : 'text-danger'
                                                }`}
                                            >
                                                {data.projekNormeGalanterija} %
                                            </div>
                                            <div className='text-muted'>Prosjek norme</div>
                                        </div>
                                    </div>

                                    <div className='col-lg-4'>
                                        <div className='border rounded p-5 h-100'>
                                            <h4 className='fw-bold mb-3'>Radni nalozi</h4>
                                            <div
                                                className={`fs-3 fw-bold ${
                                                    data.projekNormeRadniNalozi >= 100
                                                        ? 'text-success'
                                                        : 'text-danger'
                                                }`}
                                            >
                                                {data.projekNormeRadniNalozi} %
                                            </div>
                                            <div className='text-muted'>Prosjek norme</div>
                                        </div>
                                    </div>

                                    <div className='col-lg-2 text-center'>
                                        <div className='border rounded p-5 h-100'>
                                            <h4 className='fw-bold'>Ukupno</h4>
                                            <div
                                                className={`fs-1 fw-bolder ${
                                                    data.stimulacija === 'Da'
                                                        ? 'text-success'
                                                        : 'text-danger'
                                                }`}
                                            >
                                                {data.projekNormi}%
                                            </div>
                                            <div className='text-muted'>Prosjek norme</div>
                                        </div>
                                    </div>

                                    <div className='col-lg-2 text-center'>
                                        <div className='border rounded p-5 h-100'>
                                            <h4 className='fw-bold mb-3'>Stimulacija</h4>
                                            <div
                                                style={{
                                                    width: 50,
                                                    height: 50,
                                                    borderRadius: '50%',
                                                    backgroundColor:
                                                        data.procenatRada < 70
                                                            ? '#dc3545'
                                                            : data.procenatRada < 80
                                                                ? '#ffc107'
                                                                : '#198754',
                                                    margin: '0 auto',
                                                }}
                                            />
                                            <div className='mt-2 fw-bold'>
                                                {data.procenatRada < 70
                                                    ? 'Nizak učinak'
                                                    : data.procenatRada < 80
                                                        ? 'Srednji učinak'
                                                        : 'Visok učinak'}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* GALANTERIJA */}
                        {data.galanterija[0].satiUNormi > 0 && (
                            <>
                                <h2 className='my-8'>Galanterija</h2>
                                <table className='table table-bordered'>
                                    <thead className='bg-secondary-subtle'>
                                    <tr>
                                        <th>#</th>
                                        <th>Datum</th>
                                        <th>Artikal / Operacija</th>
                                        <th>Početak</th>
                                        <th>Kraj</th>
                                        <th>Min</th>
                                        <th>Količina</th>
                                        <th>Norma</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {galanterijaArray.map((item, i) => {
                                        const {date, time: start} = extractDateAndTime(item.start)
                                        const {time: end} = extractDateAndTime(item.kraj)

                                        return (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{date}</td>
                                                <td>{item.artikal} / {item.operacije}</td>
                                                <td>{start}</td>
                                                <td>{end}</td>
                                                <td>{item.radioMinuta}</td>
                                                <td>{item.uradjenoKomada}</td>
                                                <td>{item.ispunjenostNorme}</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </>
                        )}

                        {/* RADNI NALOZI */}
                        {data.nalog[0].radioSati > 0 && (
                            <>
                                <h2 className='my-8'>Radni nalozi</h2>

                                {nalogArray.map((item, index) =>
                                    item?.Id ? (
                                        <div key={index} className='mb-8'>
                                            <table className='table table-bordered'>
                                                <thead className='bg-secondary text-black'>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Broj naloga</th>
                                                    <th>Početak</th>
                                                    <th>Kraj</th>
                                                    <th>Minuta</th>
                                                    <th>Status</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>{item.Id}</td>
                                                    <td>{item.BrojNaloga}</td>
                                                    <td>{moment(item.Pocetak).format('DD-MM-YYYY HH:mm')}</td>
                                                    <td>{moment(item.Kraj).format('DD-MM-YYYY HH:mm')}</td>
                                                    <td>{item.VrijemeNalogaMinuta}</td>
                                                    <td className={item.Status === 2 ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                                                        {item.Status === 2 ? 'Završen' : 'Pauziran'}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            {item.Stavke?.length > 0 && (
                                                <table className='table table-bordered'>
                                                    <thead className='bg-secondary-subtle'>
                                                    <tr>
                                                        <th>Šifra</th>
                                                        <th>Artikal</th>
                                                        <th>Količina</th>
                                                        <th>Norma/min</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {item.Stavke.map((s, i) => (
                                                        <tr key={i}>
                                                            <td>{s.Sifra}</td>
                                                            <td>{s.Naziv}</td>
                                                            <td>{s.Kolicina}</td>
                                                           {/* <td>{s.PotrebnoVrijemeMin}</td>*/}
                                                            <td>Nije dostupno</td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    ) : null
                                )}
                            </>
                        )}
                    </div>
                )}
            </KTCardBody>
        </KTCard>
    )
}

export default RadUProizvodnji
